import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const TaggingFlowPlaceholderWrapper = styled.div`
  svg {
    display: block;
    margin: 0 auto;
  }
`;

export const Text = styled.p`
  font-family: Lato;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${grey};
`;

export const BreadcrumbPlaceholder = styled.span`
  svg {
    margin-top: 62px;
    margin-bottom: 14px;
  }
  ${Text} {
    margin-bottom: 91px;
  }
`;

export const HotkeysPlaceholder = styled.div`
  svg {
    margin-bottom: 14px;
  }
`;
